import React, { Component } from 'react';

import { ActionCreators } from '../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import '../../styles/job-detail.css';
import { newForm } from '../../config/routes';

class JobDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            job: {}
        }
    }

    componentWillMount(){
        let job_param = this.props.location.job;

        if(job_param){
            this.setState(prevState => ({
                ...prevState,
                job: job_param
            }))
        }
        else{
            this.props.jobFunction();
            this.props.jobLocation();
            this.props.jobType();
            this.props.vacancyBySlugAction(this.props.match.params.slug).then(() => {
                if(this.props.vacancyBySlug){
                    let j = this.props.vacancyBySlug;

                    if(j.jobFunctionId && this.props.jobFunctions)
                        j.jobFunction = this.props.jobFunctions.find(x => x.id === j.jobFunctionId);
                    if(j.jobTypeId && this.props.jobTypes)
                        j.jobType = this.props.jobTypes.find(x => x.id === j.jobTypeId);
                    if(j.jobLocationIds && this.props.jobLocations)
                        j.jobLocations = this.props.jobLocations.filter(x => this.props.jobLocations.map(l => l.id).indexOf(x.id) > -1);

                    this.setState(prevState => ({
                        ...prevState,
                        job: j
                    }))
                }
            })
        }
    }

    render() {
        return (
            <div className="job-detail">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <ul className="breadcrumb">
                                <li><Link to={"/job/open"}>Vacancies</Link></li>
                                <li>{ this.state.job.jobTitle }</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-8">
                            <h1>{ this.state.job.jobTitle }</h1>
                            <div className="row mb-5">
                                <div className="col">
                                    <span className="job-meta">
                                        <i className="icon-directions"></i>
                                        { this.state.job.jobFunction && this.state.job.jobFunction.function }
                                    </span>
                                    <span className="job-meta">
                                        <i className="icon-location-pin"></i>
                                        { this.state.job.jobLocations && this.state.job.jobLocations.map( l => l.location ).join(", ") }
                                    </span>
                                    <span className="job-meta">
                                        <i className="icon-clock"></i>
                                        { this.state.job.jobType && this.state.job.jobType.type }
                                    </span>
                                </div>
                            </div>
                            <h3>Description</h3>
                            <div className="row mb-5">
                                <div className="col">
                                    { this.state.job.shortDesc }
                                </div>
                            </div>
                            <h3>Requirements</h3>
                            <div className="row mb-5">
                                <div className="col">
                                    <p dangerouslySetInnerHTML={{ __html: this.state.job.requirement }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="row mb-5">
                                <div className="col">
                                {/* <Link to={{ pathname: "/job/"+this.props.match.params.slug+"/apply", job: this.state.job }} className="gs-btn gs-btn-blue">I'm Interested</Link> */}
                                <a href={newForm} target="_blank" rel="noopener noreferrer" className="gs-btn gs-btn-blue">I'm Interested</a>
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col">
                                    {
                                        this.state.job.postedBy &&
                                        <p className="text-center">posted by { this.state.job.postedBy.firstName + " " + this.state.job.postedBy.lastName }</p>
                                    }
                                </div>
                            </div> */}
                            <div className="row mb-5">
                                <div className="col text-center">
                                    Not what you had in mind?<br/>
                                    <Link to="/job/open">look for another job</Link>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col text-center">
                                    Know someone who would be perfect for this role? let them know.
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col text-center">
                                    {/* <Link target="_blank" to={"https://www.linkedin.com/shareArticle?title="+this.state.job.jobTitle+"&summary="+this.state.job.shortDesc+"&url=http://recruitments.devstack.com.au/job/"+this.props.match.params.slug+"/detail"} className="social">
                                        <i className="icon-social-linkedin"></i>
                                    </Link>
                                    <Link target="_blank" to={"https://facebook.com/sharer/sharer.php?s=100&p[url]=http://recruitments.devstack.com.au/job/"+this.props.match.params.slug+"/detail&p[title]=title"} className="social">
                                        <i className="icon-social-facebook"></i>
                                    </Link>
                                    <Link target="_blank" to="https://facebook.com/" className="social">
                                        <i className="icon-social-twitter"></i>
                                    </Link>
                                    <Link target="_blank" to="https://facebook.com/" className="social">
                                        <i className="icon-paper-plane"></i>
                                    </Link> */}
                                    <a href="#" className="social">
                                        <i className="icon-social-linkedin"></i>
                                    </a>
                                    <a href="#" className="social">
                                        <i className="icon-social-facebook"></i>
                                    </a>
                                    <a href="#" className="social">
                                        <i className="icon-social-twitter"></i>
                                    </a>
                                    <a href="#" className="social">
                                        <i className="icon-paper-plane"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        jobFunctions: state.jobFunctions,
        jobLocations: state.jobLocations,
        jobTypes: state.jobTypes,
        vacancyBySlug: state.vacancyBySlug
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobDetail));



// WEBPACK FOOTER //
// ./src/pages/unauth/jobDetail.js